import React from 'react';

import {Messages} from 'primereact/messages';
import GeneralDatatable from '../components/GeneralDatatable';

class KeyHandInOutKeysDatatable extends React.Component {

    constructor(props) {
        super(props);

        this.state={
            keyData: [],
            selectedColumns: [
                {field:'uiY_SYSTEM', header:'System'},
                {field:'uiY_LEVEL', header:'Key Level'},
                {field:'uiY_FULLCODE', header:'Full Code'},
                {field:'cabname', header:'Cabinet Name'},
                {field:'uiY_HOOKNUMBER', header:'Hook Number'}
            ],
            columnWidthTracker: "292.6,292.6,292.6,292.6,292.6",
            defaultOrder: ["uiY_SYSTEM", "uiY_LEVEL", "uiY_FULLCODE", "cabname", "uiY_HOOKNUMBER"]
        };
        this.handleWidth = this.handleWidth.bind(this);
        this.handleSelectedColumns = this.handleSelectedColumns.bind(this);
    }


    async componentDidMount() {
        let parsedTableData = JSON.parse(sessionStorage.getItem('keyDatatableTableData'));

        if(parsedTableData!==null) {
            if(parsedTableData.selectedColumns !== null) {
                this.setState({ selectedColumns: parsedTableData.selectedColumns })
            }
        }
    }

    handleWidth(width) {
        this.setState({ columnWidthTracker: width })
    }

    handleSelectedColumns(e) {
        this.setState({ selectedColumns: e })
    }

    render() {
        console.log(this.props.keyData)
        if(this.props.keyData.length===0&&!this.props.isLoading) {
            return(<div><h3>All keys are {this.props.keyStatus}.</h3></div>);
        } else {
            return(
                <div>
                    <Messages ref={(el) => this.messages = el} />
                    <GeneralDatatable 
                        columnArray = {[
                            {field:'uiY_SYSTEM', header:'System'},
                            {field:'uiY_LEVEL', header:'Key Level'},
                            {field:'uiY_FULLCODE', header:'Full Code'},
                            {field:'cabname', header:'Cabinet Name'},
                            {field:'uiY_HOOKNUMBER', header:'Hook Number'}
                        ]}

                        csvHeaders = {[
                            {key:'uiY_SYSTEM', label:'System'},
                            {key:'uiY_LEVEL', label:'Key Level'},
                            {key:'uiY_FULLCODE', label:'Full Code'},
                            {key:'cabname', label:'Cabinet Name'},
                            {key:'uiY_HOOKNUMBER', label:'Hook Number'}
                        ]}
                        
                        defaultOrder={[ "uiY_SYSTEM", "uiY_LEVEL", "uiY_FULLCODE", "cabname", "uiY_HOOKNUMBER"]}

                        tableRecords = {this.props.keyData}
                        pageNumber={39}
                        tableName={'Keys'}
                        exportFileName={'keys.csv'}
                        tableData={'keyHandOutInDatatableTableData'}
                        filterData={'keyHandOutInDatatableFilterData'}
                        columnWidthTracker={this.state.columnWidthTracker}
                        isLoading={this.props.isLoading}
                        selectedColumns={this.state.selectedColumns}
                        handleRowClick={this.props.nextStep}
                        handleWidth={this.handleWidth}
                        handleSelectedColumns={this.handleSelectedColumns}   
                    />
                </div>
            );
        }
    }
}

export default KeyHandInOutKeysDatatable;